<div class="container container-main">
  <div
    *ngIf="summaryCredit.cuotaBenefits === 0; else elseBlock"
    class="contenedor-summary"
  >
    <div class="contenedor-header-summary">
      <div *ngIf="channel != 'BNPL'" class="contenedor-title">
        <h3>Detalle de tu crédito</h3>
        <p>Acepta las condiciones</p>
      </div>
      <div *ngIf="channel == 'BNPL'" class="contenedor-title">
        <h3>Falta poco para tener tu compra</h3>
        <p>Acepta las condiciones y continua a la firma de documentos</p>
      </div>
      <div class="contenedor-img">
        <img
          src="../../../../../assets/img/imagen-onboarging.svg"
          alt="imagen-onboarging"
        />
      </div>
    </div>
    <div class="contenedor-body-summary">
      <div class="contenedor-texto">
        <p class="title">Monto a financiar</p>
        <p class="title">
          {{
            summaryCredit.amountFinance | currency : "USD" : "symbol" : "1.0-0"
          }}
        </p>
      </div>
      <div class="contenedor-texto">
        <p>Interés mensual</p>
        <p>{{ summaryCredit.rateApprobeMonth }}% E.M.</p>
      </div>
      <div class="contenedor-texto">
        <p>Interés anual</p>
        <p>{{ summaryCredit.rateApprobeAnnual }}% E.A.</p>
      </div>

      <div class="contenedor-fga">
        <div>
          <p (click)="openTermConditions(1)">
            Fianza FGA <fa-icon [icon]="circleInfo"></fa-icon>
          </p>
        </div>
        <p>{{ summaryCredit.fGA | currency : "USD" : "symbol" : "1.0-0" }}</p>
      </div>

      <div class="contenedor-texto">
        <p (click)="openTermConditions(2)">
          Tarifa de firma digital <fa-icon [icon]="circleInfo"></fa-icon>
        </p>
        <p>
          {{ signatureValue | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>

      <div class="contenedor-texto">
        <p (click)="openTermConditions(3)">
          Cuota de manejo <fa-icon [icon]="circleInfo"></fa-icon>
        </p>
        <p>
          {{
            summaryCredit.handlingFee | currency : "USD" : "symbol" : "1.0-0"
          }}
        </p>
      </div>

      <div class="contenedor-texto">
        <p (click)="openTermConditions(4)">
          Seguro vida deudor <fa-icon [icon]="circleInfo"></fa-icon>
        </p>
        <p>
          {{ summaryCredit.insurance | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>
    </div>

    <div class="contenedor-footer-summary">
      <div class="contenedor-texto">
        <p>Número de cuotas</p>
        <p>{{ summaryCredit.fees }} meses</p>
      </div>
      <div class="contenedor-gmf">
        <div>
          <p class="title">Cuota mensual</p>
        </div>
        <p class="title">
          {{ summaryCredit.paid | currency : "USD" : "symbol" : "1.0-0" }}
        </p>
      </div>
      <div class="contenedor-button">
        <button class="btn btn-azul btn-redondo" (click)="navigatePayment()">
          Aceptar
        </button>
        <a (click)="openModal()" class="style-no-acepto">No Acepto</a>
      </div>
    </div>
  </div>

  <ng-template #elseBlock>
    <div class="contenedor-summary">
      <div class="contenedor-header-summary">
        <div class="contenedor-header-summary">
          <div *ngIf="channel != 'BNPL'" class="contenedor-title">
            <h3>Detalle de tu crédito</h3>
            <p>Acepta las condiciones</p>
          </div>
          <div *ngIf="channel == 'BNPL'" class="contenedor-title">
            <h3>Falta poco para tener tu compra</h3>
            <p>Acepta las condiciones y continua a la firma de documentos</p>
          </div>
          <div class="contenedor-img">
            <img
              src="../../../../../assets/img/imagen-onboarging.svg"
              alt="imagen-onboarging"
            />
          </div>
        </div>
      </div>
      <div class="contenedor-body-summary">
        <div class="contenedor-texto">
          <p class="title">Monto a financiar</p>
          <p class="title">
            {{
              summaryCredit.amountFinance
                | currency : "USD" : "symbol" : "1.0-0"
            }}
          </p>
        </div>
        <div class="contenedor-texto">
          <p>Interés anual</p>
          <p>{{ summaryCredit.rateApprobeAnnual }}% E.A.</p>
        </div>

        <div class="contenedor-fga">
          <div>
            <p (click)="openTermConditions(1)">
              Fianza FGA <fa-icon [icon]="circleInfo"></fa-icon>
            </p>
          </div>
          <p>{{ summaryCredit.fGA | currency : "USD" : "symbol" : "1.0-0" }}</p>
        </div>

        <div class="contenedor-texto">
          <p (click)="openTermConditions(2)">
            Tarifa de firma digital <fa-icon [icon]="circleInfo"></fa-icon>
          </p>
          <p>
            {{ signatureValue | currency : "USD" : "symbol" : "1.0-0" }}
          </p>
        </div>

        <div class="contenedor-texto">
          <p (click)="openTermConditions(3)">
            Cuota de manejo <fa-icon [icon]="circleInfo"></fa-icon>
          </p>
          <p>
            {{
              summaryCredit.handlingFee | currency : "USD" : "symbol" : "1.0-0"
            }}
          </p>
        </div>

        <div class="contenedor-texto">
          <p (click)="openTermConditions(3)">
            Seguro vida deudor <fa-icon [icon]="circleInfo"></fa-icon>
          </p>
          <p>
            {{
              summaryCredit.insurance | currency : "USD" : "symbol" : "1.0-0"
            }}
          </p>
        </div>
      </div>

      <div class="contenedor-footer-summary">
        <div class="contenedor-texto">
          <p class="title">Cuotas mensuales</p>
          <p class="title">{{ summaryCredit.fees }}</p>
        </div>

        <div class="contenedor-texto borde-azul">
          <p *ngIf="summaryCredit.fees > summaryCredit.feesBenefits">
            Descuento especial en las
            <b> {{ summaryCredit.feesBenefits }}</b> primeras cuotas gracias a
            <b>{{ partnerName }}</b>
          </p>
          <p
            *ngIf="
              summaryCredit.fees <= summaryCredit.feesBenefits ||
              summaryCredit.fees == summaryCredit.feesBenefits
            "
          >
            Descuento especial en tus cuotas gracias a <b>{{ partnerName }}</b>
          </p>
        </div>

        <div class="contenedor-beneficios">
          <div class="contenedor-texto">
            <p>1ra cuota <b>con</b> beneficio</p>
            <p>
              {{
                summaryCredit.cuotaBenefits
                  | currency : "USD" : "symbol" : "1.0-0"
              }}
            </p>
          </div>
          <div *ngIf="summaryCredit.paid !== '0.0'" class="contenedor-texto">
            <p>*Cuotas <b>sin</b> beneficio</p>
            <p>
              {{ summaryCredit.paid | currency : "USD" : "symbol" : "1.0-0" }}
            </p>
            <p
              *ngIf="summaryCredit.fees > summaryCredit.feesBenefits"
              class="w-100 fuente-pequena"
            >
              *Valor de la cuota que debes pagar a partir de la cuota
              <b>#{{ summaryCredit.feesBenefits + 1 }}</b
              >.
            </p>
          </div>
        </div>

        <div class="contenedor-button">
          <button class="btn btn-azul btn-redondo" (click)="navigatePayment()">
            Aceptar
          </button>
          <a class="style-no-acepto" (click)="openModal()">No Acepto</a>
        </div>
      </div>
    </div>
  </ng-template>
</div>
